<template>
  <div class="processPage">
    <el-table :data="processList" stripe style="width: 100%" size="mini"
      :row-class-name="tableRowClassName"
      row-key="id" border lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column type="index" align="center" />
      <el-table-column label="工序编号" prop="vornr" align="center" min-width="140px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.ltxa1" :content="scope.row.enable ? scope.row.ltxa1 : '【已删除】'" class="item" effect="dark" placement="top" :open-delay="300">
            <span v-if="scope.row.enable" class="textOverflow">{{scope.row.vornr ? scope.row.vornr : '-'}}</span>
            <span v-else class="textOverflow">{{scope.row.vornr ? (scope.row.vornr+'【已删除】') : '-'}}</span>
          </el-tooltip>
          <el-tooltip v-else :content="'SAP的确认号和流水号'" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vornr}}<i class="iconfont icon-wenhao"></i></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="工作中心" prop="arbpl" show-overflow-tooltip align="center" min-width="110px">
        <template slot-scope="scope">
          <span class="textOverflow" v-if="scope.row.ktext">{{scope.row.arbpl +'('+scope.row.ktext+')'}}</span>
          <span class="textOverflow" v-else-if="scope.row.arbpl">{{scope.row.arbpl}}</span>
          <span class="textOverflow" v-else>(没有适配工作中心)</span>
        </template>
      </el-table-column>
      <el-table-column label="控制码" prop="steus" align="center">
        <template slot-scope="scope">    
          <span class="textOverflow">{{'C'==scope.row.steus ? '报工' : ('R'==scope.row.steus ? '取消报工' : '-')}}</span>                
        </template>
      </el-table-column>
      <el-table-column label="人数" prop="mgvrg" align="center" min-width="110px">
        <template slot-scope="scope">
          <span v-if="scope.row.employee">{{ scope.row.employee }}</span>
          <span v-else-if="scope.row.overtime" class="textOverflow">{{!scope.row.ltxa1 ? scope.row.mgvrg+'人(加班)' : '-'}}</span>
          <span v-else class="textOverflow">{{!scope.row.ltxa1 ? scope.row.mgvrg+'人' : '-'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="报工数/总数" prop="lmnga" align="center" min-width="110px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.ltxa1" :content="'已报工'+scope.row.lmnga+'/总数量'+scope.row.mgvrg" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.lmnga}}/{{scope.row.mgvrg}}</span>
          </el-tooltip>
          <span v-else-if="scope.row.defectiveMnga" class="textOverflow">{{scope.row.lmnga}}(异常:{{ scope.row.defectiveMnga }})</span>
          <span v-else class="textOverflow">{{scope.row.lmnga}}</span>
        </template>
      </el-table-column>
      <el-table-column label="直接人工" prop="vgw01" align="center" min-width="100px">
        <template slot-scope="scope">   
          <el-tooltip v-if="scope.row.vgwC01" :content="'标准工时：'+scope.row.vgw01+scope.row.vge01+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC01}}{{scope.row.vge01}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw01}}{{scope.row.vge01}}</span>
        </template>
      </el-table-column>
      <el-table-column label="间接人工" prop="vgw02" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.vgwC02" :content="'标准工时：'+scope.row.vgw02+scope.row.vge02+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC02}}{{scope.row.vge02}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw02}}{{scope.row.vge02}}</span>
        </template>
      </el-table-column>
      <el-table-column label="能源动力" prop="vge03" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.vgwC03" :content="'标准工时：'+scope.row.vgw03+scope.row.vge03+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC03}}{{scope.row.vge03}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw03}}{{scope.row.vge03}}</span>
        </template>
      </el-table-column>
      <el-table-column label="租金折旧" prop="vgw04" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.vgwC04" :content="'标准工时：'+scope.row.vgw04+scope.row.vge04+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC04}}{{scope.row.vge04}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw04}}{{scope.row.vge04}}</span>
        </template>
      </el-table-column>
      <el-table-column label="间接/模具" prop="vgw05" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.vgwC05" :content="'标准工时：'+scope.row.vgw05+scope.row.vge05+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC05}}{{scope.row.vge05}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw05}}{{scope.row.vge05}}</span>
        </template>
      </el-table-column>
      <el-table-column label="其他制费" prop="vgw06" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.vgwC06" :content="'标准工时：'+scope.row.vgw06+scope.row.vge06+(scope.row.mouldFactory ? ' / PCS' : ' / 1000PCS')" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{scope.row.vgwC06}}{{scope.row.vge06}}</span>
          </el-tooltip>
          <span v-else class="textOverflow">{{scope.row.vgw06}}{{scope.row.vge06}}</span>
        </template>
      </el-table-column>
      <el-table-column label="异常工时" prop="reserve1" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.reserve1 && scope.row.reserve1!='0'" :content="scope.row.reserve2 +'('+scope.row.reserve3+') ' + scope.row.reserve4" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{ scope.row.reserve1 }}H</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="报工员" max-width="70px" prop="bdmng" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.user" :content="scope.row.user.name +'('+scope.row.user.employeeNum+') ' + scope.row.createDateTime" class="item" effect="dark" placement="top" :open-delay="300">
            <span class="textOverflow">{{ scope.row.user.name }}({{scope.row.user.employeeNum}})</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" width="95px" label="操作" align="center">
        <template slot-scope="scope">
          <el-tooltip content="报工" v-if="scope.row.enable && $parent.orderStatus=='REL' && scope.row.aufnr && scope.row.mgvrg > scope.row.lmnga" class="item" effect="dark" placement="top" :open-delay="300">
            <i @click="addNewBtn($event, scope.row)" class="iconfont icon-jiedan"></i>
          </el-tooltip>
          <el-tooltip content="取消报工" v-else-if="scope.row.enable && $parent.orderStatus=='REL' && !scope.row.aufnr && !scope.row.rollbackId" class="item" effect="dark" placement="top" :open-delay="300">
            <i @click="rollbackBtn($event, scope.row)" class="iconfont icon-quxiao"></i>
          </el-tooltip>
          <span v-else>-</span>
          <!-- <el-tooltip content="报工记录" class="item" effect="dark" placement="top" :open-delay="300">
            <i @click="pauseOrder($event, scope.row)" class="iconfont icon-dingdan"></i>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <myDialog ref="myDialog"
        :title="'SAP工序报工：' + dialogForm.arbpl + ' - ' + dialogForm.ktext" width="580px" @submitData="submitData" @dialogClose="dialogClose">
      <template slot="content">
        <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" :label-width="labelWidth">
          <el-form-item label="报工产量：" prop="mnga" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999"
             v-model="dialogForm.mnga" id="rebateInput_pcs" @change="changeVgwC"/>
          </el-form-item>
          <el-form-item label="生产人数：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="2" :min="0" :max="999.99"
             v-model="dialogForm.anzma" id="rebateInput_ren" @change="changeVal2"/>
          </el-form-item>
          <el-form-item v-if="this.mouldFactory" label="工作中心：" size="small">
            <el-input v-model="dialogForm.arbpl"/>
          </el-form-item>
          <el-form-item label="直接人工：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999"
             @change="changeVal" @keyup.enter.native="syncVal"
             v-model="dialogForm.ism01" id="rebateInput1" />
          </el-form-item>
          <el-form-item label="间接人工：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999" :disabled="disabledEditHour"
             v-model="dialogForm.ism02" id="rebateInput2" />
          </el-form-item>
          <el-form-item label="能源动力：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999" :disabled="disabledEditHour"
             v-model="dialogForm.ism03" id="rebateInput3" />
          </el-form-item>
          <el-form-item label="租金折旧：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999" :disabled="disabledEditHour"
             v-model="dialogForm.ism04" id="rebateInput4" />
          </el-form-item>
          <el-form-item :label="this.mouldFactory ? '模具折旧：' : '间接费用：'" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999" :disabled="disabledEditHour"
             v-model="dialogForm.ism05" id="rebateInput5" />
          </el-form-item>
          <el-form-item label="其他制费：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999" :disabled="disabledEditHour"
             v-model="dialogForm.ism06" id="rebateInput6" />
          </el-form-item>
          <el-form-item label="异常数量：" prop="rebateInputDefectiveMnga" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999"
             v-model="dialogForm.defectiveMnga" id="rebateInputDefectiveMnga"/>
          </el-form-item>
          <el-form-item label="是否加班：" size="small" class="inlineItem">
            <el-checkbox v-model="dialogForm.overtime"></el-checkbox>
          </el-form-item>
          <el-form-item label="备注：" prop="ltxa1" size="small">
            <el-input type="textarea" maxlength="40"
              :rows="2" v-model="dialogForm.ltxa1" placeholder="备注信息" clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="异常工时：" size="small" class="inlineItem">
            <el-input-number :controls="false" :precision="3" :min="0" :max="9999999999.999"
             v-model="dialogForm.reserve1" id="reserveInput1" />
          </el-form-item>
          <el-form-item label="异常类型：" size="small" class="inlineItem">
            <el-select v-model="dialogForm.reserve2"
              @change="exceptionTypeChange">
              <el-option v-for="item in exceptionType" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="异常原因：" size="small">
            <el-select v-model="dialogForm.reserve3">
              <el-option v-for="item in exceptionType2" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="异常说明：" size="small">
            <el-input type="textarea" v-model="dialogForm.reserve4"
              :rows="2" maxlength="200" placeholder="请描述具体原因"/>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/myDialog.vue";
import {
  apiSapProcessSearch,
  apiSapOrderReported,
  apiSapOrderReportedSearch,apiSapOrderRollback
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    tabPaneData: {}
  },
  computed: {
  },
  components: {
    myDialog
  },
  created() {
    
  },
  data() {
    return {
      arbplStartWith:null,
      disabledEditHour:false,
      processList:[],
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      dialogRules: {
        mnga: [
          { required: true, message: "报工产量不能为空！", trigger: "blur" },
          {type:"number", min:0.001, message: "报工产量不能小于等于0！"}]
      },
      labelWidth: this.$store.state.labelWidth,
      disableEditHour: false,
      mouldFactory: false,
      exceptionType: ['生产品质异常','工程异常','研发设计异常','业务端异常','其它异常'],
      exceptionType2List: {
        '生产品质异常':['制程作业问题','物料来料问题','品管标准问题'],
        '工程异常':['SOP工艺问题','工装治具问题','设备问题'],
        '研发设计异常':['电路设计不良','结构设计不良','包装设计不良','软件问题','BOM出错'],
        '业务端异常':['包装说明资料错误','其他业务问题'],
        '其它异常':['PMC计划问题','资材发料问题','水电气问题','网络问题','其它原因']
      },
    exceptionType2:null
    };
  },
  methods: {    
    // 查询条件-产品类别改变
    exceptionTypeChange(value) {
      this.$set(this.dialogForm, "reserve3", undefined);
      this.exceptionType2 = this.exceptionType2List[value];
    },
    tableRowClassName({row}) {
      if (row.rollbackId) {
        return 'warning-row';
      }
      return '';
    },
    async load(row, treeNode, resolve) {
      let res = await apiSapOrderReportedSearch({
            id: row.id,
      });
      if (res.code == 0) {
        resolve(res.data);
      }   
    },
    rollbackBtn(e, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: `SAP取消报工`,
        message: h("div", null, [
          h("span", null, `请输入已报工的数量:【`),
          h("i", { style: "color: var(--themeColor)" }, row.lmnga),
          h("span", null, `】以确认取消报工！`)
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if (instance.inputValue == row.lmnga) {
              done()
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`
              })
            }
          } else {
            done()
          }
        }
      }).then(async () => {
        const res = await apiSapOrderRollback({
          id: row.id,
        });
        if (res.code == 0) {
          this.processList=[];
          this.onSearch();
          this.$message({
            message: res.msg,
            type: "success",
          });
        }          
      })
    },
    addSuffix(_id, suffix) {
      if (!document.getElementById("_suffix_"+_id)) {
        const span = document.createElement('span');
        span.id="_suffix_"+_id;
        const innerspan = document.createElement('span');
        const textspan = document.createElement('span'); 
        
        span.setAttribute("class","el-input__suffix");
        span.setAttribute("style","right:6px");
        innerspan.setAttribute("class","el-input__suffix-inner");
        
        span.append(innerspan)
        innerspan.append(textspan)
        textspan.append(suffix)
        
        document.getElementById(_id).lastElementChild.prepend(span);
      }
    },
    changeVgwC(val) {
      if (val>0) {
        if (this.tabPaneData && this.tabPaneData.productType=='模具成品') {
          val = val*this.dialogForm.vgw;  // 模具成品按1:1计算成本
        } else {
          val = val*this.dialogForm.vgw/1000.0; // 其它产品按1:1000计算成本
        }
        let title = document.querySelector("head title").innerText;
        if (!title.startsWith("越南")) {
          this.dialogForm.ism01 = val;
          if (this.dialogForm.anzma>0) {
            this.changeVal2(this.dialogForm.anzma);
          } else {
            this.changeVal(this.dialogForm.ism01);
          }
        } else {
          this.disabledEditHour = false;
        }
      }
    },
    changeVal2(val) {
      if (!this.disabledEditHour && val>0 && this.dialogForm.ism01>0) {
        let title = document.querySelector("head title").innerText;
        if (!title.startsWith("越南")) {
          this.dialogForm.ism02=this.dialogForm.ism01/val;
          this.dialogForm.ism03=this.dialogForm.ism01/val;
          this.dialogForm.ism04=this.dialogForm.ism01/val;
          this.dialogForm.ism05=this.dialogForm.ism01/val;
          this.dialogForm.ism06=this.dialogForm.ism01/val;
        } else {
          this.disabledEditHour = false;
        }
      }
    },
    syncVal() {
      this.changeVal(this.dialogForm.ism01);
    },
    changeVal(val) {
      if (!this.disabledEditHour && this.dialogForm.anzma>0) {
        let title = document.querySelector("head title").innerText;
        if (!title.startsWith("越南")) {
          this.dialogForm.ism02=val/this.dialogForm.anzma;
          this.dialogForm.ism03=val/this.dialogForm.anzma;
          this.dialogForm.ism04=val/this.dialogForm.anzma;
          this.dialogForm.ism05=val/this.dialogForm.anzma;
          this.dialogForm.ism06=val/this.dialogForm.anzma;
        } else {
          this.disabledEditHour = false;
        }
      } else {        
        let title = document.querySelector("head title").innerText;
        if (!title.startsWith("越南")) {
          this.dialogForm.ism02=val;
          this.dialogForm.ism03=val;
          this.dialogForm.ism04=val;
          this.dialogForm.ism05=val;
          this.dialogForm.ism06=val;
        } else {
          this.disabledEditHour = false;
        }
      }
    },
    addNewBtn(e, row) {
      if (!row.arbpl)  {
        this.$message({
          message: "工序没有绑定【工作中心】，请联系PMC处理！",
          type: "error",
        });
        return;
      }
      this.mouldFactory = row.mouldFactory;
      this.disabledEditHour = !row.canEditHour;
      this.dialogTitle = "SAP工序报工";
      this.$refs.myDialog.dialogVisible = true;
      
      if (row.arbpl && row.arbpl.length>5) {
        this.arbplStartWith = row.arbpl.substring(0,5);
      } else {
        this.arbplStartWith = null;
      }
      
      this.dialogForm = {
        id: row.id,
        arbpl: row.arbpl,
        ktext: row.ktext,
        mnga:0,
        anzma:0,
        ism01:0,
        ile01: "H",
        ism02:0,
        ile02: "H",
        ism03:0,
        ile03: "H",
        ism04:0,
        ile04: "H",
        ism05:0,
        ile05: "H",
        ism06:0,
        ile06: "H",
        reserve1: 0,
        defectiveMnga: 0,
        vgw: row.vgw01
      };

      setTimeout(() => {
      // 为el-input-number添加单位
      this.addSuffix("rebateInput_pcs", "PCS");
      this.addSuffix("rebateInput_ren", "人");
      this.addSuffix("rebateInput1", "H");
      this.addSuffix("rebateInput2", "H");
      this.addSuffix("rebateInput3", "H");
      this.addSuffix("rebateInput4", "H");
      this.addSuffix("rebateInput5", "H");
      this.addSuffix("rebateInput6", "H");
      this.addSuffix("reserveInput1", "H");
      this.addSuffix("rebateInputDefectiveMnga", "PCS");
      }, 100);
    },
    // 确认报工
    async submitData() {
      this.$refs.dialogForm.validate(async (valid) => {        
        if (valid) {
          if (this.arbplStartWith && !this.dialogForm.arbpl.startsWith(this.arbplStartWith)) {
            this.$message({
              message: "不能将【"+this.arbplStartWith+"】的工序报工给其它工作中心【"+this.dialogForm.arbpl+"】",
              type: "error",
            });
            return;
          }
          this.syncVal(); // 同步一次直接人工和间接人工
          let res = await apiSapOrderReported({
            ...this.dialogForm,
          });
          if (res.code == 0) {
            this.processList=[];
            this.$refs.myDialog.dialogVisible = false;
            this.onSearch();
            this.$message({
              message: "SAP工序报工成功！",
              type: "success",
            });
          }
        }
      });      
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      // this.dialogForm = {
      // };
    },
    async onSearch(callback) {
      const res = await apiSapProcessSearch({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.processList = res.data;
        this.$parent.orderStatus = (res.data2 ? res.data2.orderStatus : null);
        if (callback) callback();
      }
    }
  }
};
</script>
<style>
  .el-table .warning-row {
    color: #F56C6C;
  }
  .icon-wenhao {
    color: var(--textRegular); vertical-align: super; margin-left: 2px; font-size: 12px;
  }
  .processPage .el-table {
    /* 确保行悬停背景色覆盖整行所有列 */
    tbody tr:hover td {
      background-color: var(--bgHover) !important;
    }
    /* 斑马纹行的悬停背景色覆盖 */
    .el-table__row--striped:hover td {
      background-color: var(--bgHover) !important;
    }
  }
</style>